<template>
    <v-app color="blue">
        <v-form ref="refMain">
            <v-container fluid>
                <v-row fluid style="background-color:#DDD">
                    <v-col cols="12" sm="12" md="3" lg="3" class="pa-1">
                        <v-autocomplete v-model="dSearch.IdServicio" label="* Carrera Profesional"
                            :items="ssPriServiciosIngreso"  item-value="IdServicio" item-text="Descripcion2"
                            filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2" class="pa-1">
                        <v-autocomplete v-model="dSearch.IdPeriodo" label="* Periodo"
                            :items="dMatPeriodos"  item-value="IdPeriodo" item-text="Periodo"
                            filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2" class="pa-1">
                        <v-select v-model="dSearch.fechaCalificacion" label="Mes" :items="this.dYearMonth" filled>
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="3" lg="3" class="pa-1">
                        <v-autocomplete v-model="dSearch.IdSeccion" label="* Sección"
                            :items="dMATSECCIONESSelect"
                            prepend-inner-icon="bookmark" filled multiple chips clearable deletable-chips small-chips :rules="[v => !!v || 'El campo es requerido']">
                            <template #selection="{ item }">
                                <v-chip color="primary" small>{{item.text}}</v-chip>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" lg="2" class="pa-1">
                        <v-btn @click.prevent="fuSearch" :loading="dTable.loading" color="blue-grey" dark x-large><v-icon large left>search</v-icon> Buscar</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
        <v-card>
            <v-data-table
                v-model="dTable.selected"
                :headers="dTable.headers"
                :loading="dTable.loading"
                :search="dTable.search"
                :items="dCCEDOCENTECURSOASPECTO"
                item-key="IdSeccion_IdCursoCurricula_IdPersonal"
                show-select
                class="elevation-1" :items-per-page="-1">
                <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
                <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
                <template v-slot:[`item.Seccion`]="{ item }">
                    <span :title="item.IdSeccion">{{fuSeccionName(item.IdSeccion)}}</span>
                </template>
                <template v-slot:[`item.id`]="{ item }">
                    <v-chip v-if="item.id" color="primary">Actividad</v-chip>
                </template>
            </v-data-table>
        </v-card>
        <div class="pa-2 blue-grey darken-2">
            <v-btn color="primary" class="ma-1" dark @click="fuExecute('Agregar')"><v-icon left>work</v-icon> Agregar Actividad</v-btn>
            <v-btn color="error" class="ma-1" dark @click="fuExecute('Eliminar')"><v-icon left>work_off</v-icon> Eliminar Actividad</v-btn>
        </div>
        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
        </v-snackbar>
    </v-app>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import { fuMesNombreShort } from '@/helpers/index.js';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { fuMesNombre } from '@/helpers/index.js';

export default {
    name: 'TestDocente',
    mounted(){        
        let today = new Date();
        for (var i = today.getFullYear()+1; i >= today.getFullYear()-20; i--) {
            this.dMatPeriodos.push(i+'-2');
            this.dMatPeriodos.push(i+'-1');
        }

        for (var i = 0; i <= 5; i++) {
            let vFecha = new Date(new Date(today).setMonth(today.getMonth() - i))
            this.dYearMonth.push({
                value: [vFecha.getFullYear(), (vFecha.getMonth() + 1).toString().padStart(2, '0'), '15'].join(''),
                text: vFecha.getFullYear() +' '+ fuMesNombre(vFecha.getMonth()+1)
            });
        }
    },
    data: () => ({
        dYearMonth: [],
        dMatPeriodos: [],
        dMATSECCIONES: [],
        dMATSECCIONESSelect: [],
        dCCEDOCENTECURSOASPECTO: [],
        dccedocentecursoaspectoByIdSeccions: [],
        dSearch: {
            fechaCalificacion: null,// new Date().getFullYear() +'_'+ new Date().getMonth(),
            IdServicio: null,
            IdPeriodo: null,
            IdSeccion: null,
        },
        dSnackbar: false,
        dTable: {
            headers: [
                {value: 'IdSeccion_IdCursoCurricula_IdPersonal', text: 'IdSeccion_IdCursoCurricula_IdPersonal', align: ' d-none'},
                {value: 'IdCursoCurricula', text: 'IdCursoCurricula', align: ' d-none'},
                {value: 'IdCurso', text: 'IdCurso', align: ' d-none'},
                {value: 'Seccion', text: 'Seccion'},
                {value: 'Curso', text: 'Curso'},
                {value: 'Personal', text: 'Personal'},
                {value: 'IdSeccion', text: 'IdSeccion', align: ' d-none'},
                {value: 'IdPersonal', text: 'IdPersonal', align: ' d-none'},
                {value: 'id', text: 'Actividad'},
            ],
            loading: false,
            search: null,
            selected: []
        },
    }),
    computed: {
        ...mapState(['ssUser', 'ssPriServiciosIngreso']),
    },
    watch: {
        'dSearch.IdServicio' (val) {
            this.dSearch.IdPeriodo = '';
            this.dSearch.IdSeccion = '';
            this.dMATSECCIONES = [];
            this.dMATSECCIONESSelect = [];
        },
        'dSearch.fechaCalificacion' (val) {
            if(val){
                this.fuMATSECCIONESSelectPush(val.substring(4,6));
            }
        },
        async 'dSearch.IdPeriodo' (val) {
            this.dSearch.IdSeccion = '';
            this.dSearch.fechaCalificacion = null;
            this.dMATSECCIONES = [];
            this.dMATSECCIONESSelect = [];

            if(this.dSearch.IdServicio && val){
                const vAnioPeriodo = this.dSearch.IdPeriodo.split("-");

                const response = await this.$apollo.query({
                    query: gql`
                        query consulta($IdServicio: Int!, $Anio: Int!, $Periodo: Int!){
                            matperiodoByIdServicioByAnioByPeriodo(IdServicio:$IdServicio,Anio:$Anio,Periodo:$Periodo){
                                Anio
                                Periodo
                                Nivel
                                matseccions{
                                    IdSeccion
                                    Seccion
                                    FechaInicio
                                    Concluyo
                                    especial
                                }
                                priservicio{
                                    Iniciales
                                }
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdServicio: this.dSearch.IdServicio,
                        Anio: vAnioPeriodo[0],
                        Periodo: vAnioPeriodo[1],
                    }
                });
                if(response.data.matperiodoByIdServicioByAnioByPeriodo.length>0){
                    response.data.matperiodoByIdServicioByAnioByPeriodo.map(item =>{
                        Array.from(item.matseccions).map(elem =>{
                            if (elem.especial==0){
                                var vFechaInicio = new Date(elem.FechaInicio);

                                this.dMATSECCIONES.push({
                                    IdSeccion: elem.IdSeccion,
                                    Seccion: item.Nivel+elem.Seccion+" "+ fuMesNombreShort(parseInt(elem.FechaInicio.substring(5,7)))+" "+parseInt(elem.FechaInicio.substring(8,10)),
                                    mes: [
                                        vFechaInicio.getMonth(),
                                        new Date(new Date(vFechaInicio).setMonth(vFechaInicio.getMonth() + 1)).getMonth(),
                                        new Date(new Date(vFechaInicio).setMonth(vFechaInicio.getMonth() + 2)).getMonth(),
                                        new Date(new Date(vFechaInicio).setMonth(vFechaInicio.getMonth() + 3)).getMonth()
                                    ]
                                });
                            }
                            return true;
                        });
                        return true;
                    });
                    this.dMATSECCIONES = this.dMATSECCIONES.sort((p1, p2) => (p1.Seccion < p2.Seccion) ? -1 : (p1.Seccion > p2.Seccion) ? 1 : 0);                    
                    // this.fuMATSECCIONESSelectPush(this.dSearch.fechaCalificacion);
                }
            }
        },
    },
    methods: {
        fuMATSECCIONESSelectPush(vMes){
            vMes--;
            
            this.dMATSECCIONESSelect = [];
            this.dSearch.IdSeccion = null;
            let vDisabled=true;

            this.dMATSECCIONES.map(item =>{
                vDisabled=true;
                if(item.mes.includes(vMes))
                    vDisabled=false;

                this.dMATSECCIONESSelect.push({
                    text: item.Seccion,
                    value: item.IdSeccion,
                    disabled: vDisabled,
                    mes: item.mes,
                })
                return true;
            })
        },
        async fuSearch(){
            if(!this.$refs.refMain.validate()){
                this.dSnackbar = true;
            } else {
                this.dTable.loading = true;
                this.dTable.search = '';
                this.dTable.selected = [];
                this.dCCEDOCENTECURSOASPECTO = [];
                let vmatseccionByIdSeccions = null;

                try {
                    const response = await this.$apollo.query({
                        query: gql`query matseccionByIdSeccions($IdSeccions: String!){
                            matseccionByIdSeccions(IdSeccions: $IdSeccions){
                                IdSeccion
                                matcargadocente{
                                    pripersonal{
                                        IdPersonal
                                        Personal
                                    }
                                    IdCursoCurricula
                                    matcursoscurricula{
                                        IdCurso
                                        matcurso{
                                            Descripcion
                                        }
                                    }
                                }
                            },
                            ccedocentecursoaspectoByIdSeccions(IdSeccions: $IdSeccions){
                                id
                                IdSeccion
                                IdCursoCurricula
                                IdPersonal
                                fechaCalificacion
                            }
                        }`,
                        variables: {
                            IdSeccions: this.dSearch.IdSeccion.toString(),
                        },
                        fetchPolicy: 'no-cache'
                    });

                    this.dccedocentecursoaspectoByIdSeccions = response.data.ccedocentecursoaspectoByIdSeccions.map(item => ({
                        ...item,
                        fechaCalificacion: moment(item.fechaCalificacion).format("YYYYMMDD"),
                    }));

                    vmatseccionByIdSeccions = response.data.matseccionByIdSeccions;
                } catch (error) {
                    console.log(error);
                    Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
                } finally {
                    this.dTable.loading = false;

                    vmatseccionByIdSeccions.map(item => {
                        item.matcargadocente.map(item2 => {
                            let vFind = null;
                            let vItem = null;
                            vFind = this.dccedocentecursoaspectoByIdSeccions.find(el => el.IdSeccion == item.IdSeccion && el.IdCursoCurricula == item2.IdCursoCurricula && el.IdPersonal == item2.pripersonal.IdPersonal && el.fechaCalificacion == this.dSearch.fechaCalificacion);

                            this.dCCEDOCENTECURSOASPECTO.push({
                                IdCursoCurricula: item2.IdCursoCurricula,
                                IdCurso: item2.matcursoscurricula.IdCurso,
                                Curso: item2.matcursoscurricula.matcurso.Descripcion,
                                IdSeccion: item.IdSeccion,
                                IdSeccion_IdCursoCurricula_IdPersonal: item.IdSeccion + '_' + item2.IdCursoCurricula + '_' + item2.pripersonal.IdPersonal,
                                IdPersonal: item2.pripersonal.IdPersonal,
                                Personal: item2.pripersonal.Personal,
                                fechaCalificacion: this.dSearch.fechaCalificacion,
                                id: vFind ? vFind.id: null
                            });
                        })
                        return true;
                    });
                }
            }
        },
        fuSeccionName(pIdSeccion){
            let vItem = this.dMATSECCIONES.find(el => el.IdSeccion === pIdSeccion);

            if (vItem)
                return this.dSearch.IdPeriodo + " " + vItem.Seccion;
            return '';
        },
        fuExecute(vAccion){            
            if(!this.dTable.selected){
                Swal.fire('Información', 'Debe seleccionar un elemento', 'info');
            } else {
                if(this.dTable.selected.length==0)
                    Swal.fire('Información', 'Debe seleccionar un elemento', 'info');
                else{
                    if(vAccion == 'Agregar')
                        this.fuccedocentecursoaspectoCreateIds();
                    else
                        this.fuccedocentecursoaspectoDeleteIds();
                }
            }
        },
        async fuccedocentecursoaspectoCreateIds(){
            let vIds = this.dTable.selected.map(x=>x.IdSeccion_IdCursoCurricula_IdPersonal).join(",");
            
            this.dTable.loading = true;
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation ccedocentecursoaspectoCreateIds($Ids: String!, $IdAspecto: Int!, $fechaCalificacion: String!, $calificacion: Int!, $created_by: Int!){
                        ccedocentecursoaspectoCreateIds(Ids: $Ids, IdAspecto: $IdAspecto, fechaCalificacion: $fechaCalificacion, calificacion: $calificacion, created_by: $created_by){
                            error
                        }
                    }`,
                    variables: {
                        Ids : vIds,
                        IdAspecto: 10,
                        fechaCalificacion: this.dSearch.fechaCalificacion,
                        calificacion: 1,
                        created_by: this.ssUser.IdPersonal,
                    }
                });
                if(response.data.ccedocentecursoaspectoCreateIds.error != 0){
                    Swal.fire('¡ ERROR !', 'Registro incorrecto', 'error');
                } else {
                    Swal.fire('CORRECTO', 'Registro correcto', 'success');
                    this.fuSearch();
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dTable.loading = false;
            }
        },
        async fuccedocentecursoaspectoDeleteIds(){
            let vIds = this.dTable.selected.map(x=>x.id).join(",");
            
            this.dTable.loading = true;
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation ccedocentecursoaspectoDeleteIds($Ids: String!){
                        ccedocentecursoaspectoDeleteIds(Ids: $Ids){
                            error
                        }
                    }`,
                    variables: {
                        Ids : vIds,
                    }
                });
                if(response.data.ccedocentecursoaspectoDeleteIds.error != 0){
                    Swal.fire('¡ ERROR !', 'Eliminacion incorrecta', 'error');
                } else {
                    Swal.fire('CORRECTO', 'Eliminacion correcta', 'success');
                    this.fuSearch();
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dTable.loading = false;
            }
        },
    }
}
</script>
